import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const stats = [{
    label: 'Our Promise',
    value: 'Sustainably Selected, Exclusively Delivered'
  }, {
    label: 'Heritage',
    value: 'Loire Valley'
  }, {
    label: 'Minimum Order',
    value: '12 Bottles'
  }];
  return <section id="about" className="py-24 bg-cream overflow-hidden" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="max-w-3xl mx-auto" data-id="element-22">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="flex flex-col justify-center text-center" data-id="element-23">
            <span className="text-wine font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-24">
              Our Story
            </span>
            <h2 className="font-playfair text-4xl md:text-5xl text-charcoal font-bold mb-6 leading-tight" data-id="element-25">
              Wine,{' '}
              <span className="italic text-wine font-normal" data-id="element-26">Reimagined</span>
            </h2>

            <div className="space-y-6 text-brown/80 text-lg leading-relaxed mb-10" data-id="element-27">
              <p data-id="element-28">
                At Wine & Design, our aim is to improve how wine is selected,
                consumed, and presented. We believe that a great bottle of wine
                is more than just a drink—it's a memory waiting to be uncorked.
              </p>
              <p data-id="element-29">
                We partner primarily with esteemed vineyards to bring you
                curated selections of exceptional quality. We are especially
                proud of our deep heritage and partnership with the historic{' '}
                <a href="https://chaintres.fr/" target="_blank" rel="noopener noreferrer" className="text-wine font-bold underline hover:text-gold transition-colors" data-id="element-30">
                  Chateau de Chaintres
                </a>
                , a magnificent castle and vineyard based in the breathtaking
                Loire Valley in France.
              </p>
              <p data-id="element-31">
                By offering custom label services starting at just 12 bottles,
                we make the experience personal, accessible, and memorable for
                clients without ever compromising on quality.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-wine/10" data-id="element-32">
              {stats.map((stat, index) => <div key={index} className="text-center lg:text-left" data-id="element-33">
                  <div className="font-playfair text-2xl md:text-3xl text-wine font-bold mb-1" data-id="element-34">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-brown/60 uppercase tracking-wider font-medium" data-id="element-35">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}